export default {
  'https://pila.cand.li/pila.html?tutorial': { name: 'Cand.li Tutorial' },
  'https://pila.cand.li/pila.html?level1': { name: 'Cand.li Level 1' },
  'https://pila.cand.li/pila.html?level2': { name: 'Cand.li Level 2' },
  'https://pila.cand.li/pila.html?level3': { name: 'Cand.li Level 3' },
  'https://bettysbrain.knowlearning.systems/bb/practice?oecd=true&disable-guide=true': { name: "Betty's Brain Predator/Prey" },
  'https://bettysbrain.knowlearning.systems/bb/climate-change?oecd=true&disable-guide=true': { name: "Betty's Brain Climate" },
  'https://bettysbrain.knowlearning.systems/bb/thermoregulation?oecd=true&disable-guide=true': { name: "Betty's Brain Thermoregulation" }
}